var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('appHeader'),_c('b-container',{staticClass:"wrapper d-flex flex-column",staticStyle:{"min-height":"calc(100vh - 160px)"}},[_c('router-view')],1),_c('appFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }